// extracted by mini-css-extract-plugin
export default {"container":"RestoreHistoryButton-module__container--nCIaM","iconButton":"RestoreHistoryButton-module__iconButton--_4RnZ","button":"RestoreHistoryButton-module__button--STzt2"};